import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BorghiPage from "../pages/borghi/page";
import BorgoDetailPage from "../pages/borghi/[slug]/page";
// import ImmobiliPage from "../pages/immobili/page";
// import ImmobileDetailPage from "../pages/immobili/[slug]/page";
import BlogPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blog/[slug]/page";
import ServiziPage from "../pages/servizi/page";
import PartnerPage from "../pages/partner/page";
import ContattiPage from "../pages/contatti/page";
import MoveToMarchePage from "../pages/move-to-marche/page";
import GuidaAcquistoPage from "../pages/guida-acquisto/page";
import ProgettoPage from "../pages/progetto/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import CookiePolicyPage from "../pages/cookie-policy/page";
import PageLayout from "../pages/layout/PageLayout";
import GestioneRecensioniPage from "../pages/gestione-recensioni/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/borghi",
    element: <PageLayout><BorghiPage /></PageLayout>,
  },
  {
    path: "/borghi/:slug",
    element: <PageLayout><BorgoDetailPage /></PageLayout>,
  },
  // { path: "/immobili", element: <PageLayout><ImmobiliPage /></PageLayout> },
  // { path: "/immobili/:slug", element: <PageLayout><ImmobileDetailPage /></PageLayout> },
  {
    path: "/blog",
    element: <PageLayout><BlogPage /></PageLayout>,
  },
  {
    path: "/blog/:slug",
    element: <PageLayout><BlogDetailPage /></PageLayout>,
  },
  {
    path: "/servizi",
    element: <PageLayout><ServiziPage /></PageLayout>,
  },
  {
    path: "/partner",
    element: <PageLayout><PartnerPage /></PageLayout>,
  },
  {
    path: "/contatti",
    element: <PageLayout><ContattiPage /></PageLayout>,
  },
  {
    path: "/move-to-marche",
    element: <PageLayout><MoveToMarchePage /></PageLayout>,
  },
  {
    path: "/guida-acquisto",
    element: <PageLayout><GuidaAcquistoPage /></PageLayout>,
  },
  {
    path: "/progetto",
    element: <PageLayout><ProgettoPage /></PageLayout>,
  },
  {
    path: "/privacy-policy",
    element: <PageLayout><PrivacyPolicyPage /></PageLayout>,
  },
  {
    path: "/cookie-policy",
    element: <PageLayout><CookiePolicyPage /></PageLayout>,
  },
  {
    path: "/gestione-recensioni",
    element: <GestioneRecensioniPage />,
  },
  {
    path: "/recensioni",
    element: <Navigate to="/#recensioni" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
